import { render } from "./pokemonPage.vue?vue&type=template&id=fa5b819c"
import script from "./pokemonPage.vue?vue&type=script&lang=js"
export * from "./pokemonPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CarlosRocha\\Vue\\Pokemon Game Wirh Vue\\04-pokemon-game-with-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__